const MAX_MANDATE_REFERENCE_LENGTH = 35;
const MAX_INVOICE_EMAIL_LENGTH = 50;

export {
  MAX_MANDATE_REFERENCE_LENGTH,
  MAX_INVOICE_EMAIL_LENGTH
}
